import React from "react";
import _ from "lodash";
import * as Icon from "react-feather";

import "./tools-client-search.css";

import WComponent from "../../../common/WComponent";
import ClientService from "../../../../services/ClientService";
import UtilityService from "../../../../services/UtilityService";

const SEARCH_DEBOUNCE_MILLISECONDS = 300;
const FEWEST_SEARCH_CHARACTERS = 2;
const MOST_MATCHES_SHOWN = 6;

class ToolsClientSearch extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			search: "",
			matches: [],
			searchError: null,
		};

		this.findClientsSoon = _.debounce(this.findClients, SEARCH_DEBOUNCE_MILLISECONDS);
	}

	componentWillUnmount() {
		this.findClientsSoon.cancel();
	}

	findClients = async () => {
		const search = this.state.search.trim();
		if (search.length < FEWEST_SEARCH_CHARACTERS) {
			await this.update({ matches: [], searchError: null });
			return;
		}
		try {
			const response = await ClientService.searchClients({ search });
			const clients = response && response.data ? response.data : [];
			await this.update({ matches: clients.slice(0, MOST_MATCHES_SHOWN), searchError: null });
		} catch (error) {
			await this.update({
				matches: [],
				searchError: UtilityService.describeRequestError({ error, fallback: "Clients could not be searched. Try again." }),
			});
		}
	};

	onSearchChanged = async event => {
		await this.update({ search: event.target.value });
		this.findClientsSoon();
	};

	onChoose = async ({ client }) => {
		const { onChoose } = this.props;
		this.findClientsSoon.cancel();
		await this.update({ search: "", matches: [], searchError: null });
		onChoose({ client: { id: client.id, name: client.name, type: client.type } });
	};

	render() {
		const { chosen, onClear, placeholder = "Find the client…", disabled } = this.props;
		const { search, matches, searchError } = this.state;

		if (chosen) {
			return (
				<div className="tools-client-search tools-client-search--chosen">
					<Icon.Briefcase size={13} className="tools-client-search__icon" />
					<span className="tools-client-search__name">{chosen.name}</span>
					<button type="button" className="tk-text-action tk-text-action--muted" onClick={onClear} disabled={disabled}>
						Change
					</button>
				</div>
			);
		}

		return (
			<div className="tools-client-search">
				<input className="tk-input" value={search} onChange={this.onSearchChanged} placeholder={placeholder} disabled={disabled} />
				{matches.length > 0 && (
					<div className="tools-client-search__matches">
						{matches.map(client => (
							<button key={client.id} type="button" className="tools-client-search__match" onClick={() => this.onChoose({ client })}>
								{client.name}
							</button>
						))}
					</div>
				)}
				{searchError && <span className="tools-client-search__error">{searchError}</span>}
			</div>
		);
	}
}

export default ToolsClientSearch;
